export enum Sticky
{
	Off = 0,
	Always = 1,
	ActivitiesBefore = 2,
	ActivitiesAfter = 3,
	ActivitiesBeforeOrAfter = 4
}